import { Trans } from '@lingui/macro'
import { authRoles } from 'app/auth/authRoles'
import { EgretLoadable } from 'egret'

export const resourceInventoryPaths = {
  resourceInventory: '/resource-inventory/list',
  resourceInventoryMyShelf: '/resource-inventory/my-shelf',
  resourceInventoryMyEntries: '/resource-inventory/my-entries',
  resourceInventorySubmitResource: '/resource-inventory/submit-resource'
}

const MyEntries = EgretLoadable({
  loader: () => import('./ResourceInventoryMyEntries')
})

const MyShelf = EgretLoadable({
  loader: () => import('./MyShelfPage')
})

const ResourceInventory = EgretLoadable({
  loader: () => import('./ResourceInventory')
})

const CreateNewResource = EgretLoadable({
  loader: () =>
    import('../resources/ResourceInventoryMyEntries/CreateNewResource')
})

export const resourceInventoryRoutes = [
  {
    path: resourceInventoryPaths.resourceInventory,
    component: ResourceInventory,
    auth: authRoles.grantee,
    isTranslatable: true,
    label: <Trans>NAVIGATIONS_RESOURCES</Trans>
  },
  {
    path: resourceInventoryPaths.resourceInventoryMyShelf,
    component: MyShelf,
    auth: authRoles.grantee,
    isTranslatable: true,
    label: <Trans>NAVIGATIONS_MY_SHELF</Trans>,
    showCollapseBtn: true
  },
  {
    path: resourceInventoryPaths.resourceInventoryMyEntries,
    component: MyEntries,
    auth: authRoles.grantee,
    isTranslatable: true,
    label: <Trans>NAVIGATIONS_MY_RESOURCE_ENTRIES</Trans>,
    showCollapseBtn: true
  },
  {
    path: resourceInventoryPaths.resourceInventorySubmitResource + '/:id?',
    component: CreateNewResource,
    auth: authRoles.grantee,
    isTranslatable: true,
    label: <Trans>GRANTS_ROUTES_RESOURCE_INVENTORY_SUBMIT_RESOURCE_LABEL</Trans>
  }
]
